import * as actions from './sensorManagementActions';

const initialState = {
    sensors: [],
    userOrganizations: {
        owned: [],
        member: []
    },
    isLoading: false,
    isCreating: false,
    isUpdating: false,
    isDeleting: false,
    isLoadingOrganizations: false,
    error: null,
    createError: null,
    updateError: null,
    deleteError: null,
    organizationsError: null,
};

const sensorManagementReducer = (state = initialState, action) => {
    switch (action.type) {
        // FETCH SENSORS
        case actions.FETCH_SENSORS.REQUEST:
            return {
                ...state,
                isLoading: true,
                error: null
            };
        case actions.FETCH_SENSORS.SUCCESS:
            return {
                ...state,
                sensors: action.payload,
                isLoading: false,
                error: null
            };
        case actions.FETCH_SENSORS.FAILURE:
            return {
                ...state,
                isLoading: false,
                error: action.payload
            };

        // CREATE SENSOR
        case actions.CREATE_SENSOR.REQUEST:
            return {
                ...state,
                isCreating: true,
                createError: null
            };
        case actions.CREATE_SENSOR.SUCCESS:
            return {
                ...state,
                sensors: [action.payload, ...state.sensors],
                isCreating: false,
                createError: null
            };
        case actions.CREATE_SENSOR.FAILURE:
            return {
                ...state,
                isCreating: false,
                createError: action.payload
            };

        // UPDATE SENSOR
        case actions.UPDATE_SENSOR.REQUEST:
            return {
                ...state,
                isUpdating: true,
                updateError: null
            };
        case actions.UPDATE_SENSOR.SUCCESS:
            return {
                ...state,
                sensors: state.sensors.map((sensor) =>
                    sensor.id === action.payload.id ? action.payload : sensor
                ),
                isUpdating: false,
                updateError: null
            };
        case actions.UPDATE_SENSOR.FAILURE:
            return {
                ...state,
                isUpdating: false,
                updateError: action.payload
            };

        // DELETE SENSOR
        case actions.DELETE_SENSOR.REQUEST:
            return {
                ...state,
                isDeleting: true,
                deleteError: null
            };
        case actions.DELETE_SENSOR.SUCCESS:
            return {
                ...state,
                sensors: state.sensors.filter((sensor) => sensor.id !== action.payload),
                isDeleting: false,
                deleteError: null
            };
        case actions.DELETE_SENSOR.FAILURE:
            return {
                ...state,
                isDeleting: false,
                deleteError: action.payload
            };

        // TOGGLE SENSOR ACTIVE
        case actions.TOGGLE_SENSOR_ACTIVE.REQUEST:
            return {
                ...state,
                isUpdating: true,
                updateError: null
            };
        case actions.TOGGLE_SENSOR_ACTIVE.SUCCESS:
            return {
                ...state,
                sensors: state.sensors.map((sensor) =>
                    sensor.id === action.payload.id ? action.payload : sensor
                ),
                isUpdating: false,
                updateError: null
            };
        case actions.TOGGLE_SENSOR_ACTIVE.FAILURE:
            return {
                ...state,
                isUpdating: false,
                updateError: action.payload
            };

        // FETCH USER ORGANIZATIONS
        case actions.FETCH_USER_ORGANIZATIONS.REQUEST:
            return {
                ...state,
                isLoadingOrganizations: true,
                organizationsError: null
            };
        case actions.FETCH_USER_ORGANIZATIONS.SUCCESS:
            return {
                ...state,
                userOrganizations: action.payload,
                isLoadingOrganizations: false,
                organizationsError: null
            };
        case actions.FETCH_USER_ORGANIZATIONS.FAILURE:
            return {
                ...state,
                isLoadingOrganizations: false,
                organizationsError: action.payload
            };

        // CLEAR DATA
        case actions.CLEAR_SENSOR_MANAGEMENT_DATA:
            return initialState;

        default:
            return state;
    }
};

export default sensorManagementReducer;
